import { useIntl } from 'react-intl'

export const useTranslation = (prefix) => {
  const intl = useIntl()

  const t = (key, variables, skipPrefix) =>
    intl.formatMessage(
      { id: !skipPrefix && prefix ? `${prefix}.${key}` : key },
      variables
    )

  return { t, intl }
}
